import { ChangeDetectionStrategy, Component, Type, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ARTIFACT_RENDERERS } from '../../models/artifact.model';
import { ArtifactService } from '../../services/artifact.service';
import { MarkdownArtifactComponent } from '../artifact-renderers/markdown-artifact.component';

/**
 * The right-side report panel (third column). Subscribes to ArtifactService and
 * renders whichever artifact is active, choosing the body component from the
 * ARTIFACT_RENDERERS registry by `artifact.type`. Owns the header actions
 * (open in new tab / download / close) and a footer cross-link into the
 * Workspace report library. Renders nothing when the panel is closed — the
 * parent layout collapses its width.
 */
@Component({
  selector: 'app-report-panel',
  standalone: true,
  imports: [NgComponentOutlet, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './report-panel.component.html',
  styleUrls: ['./report-panel.component.scss'],
})
export class ReportPanelComponent {
  readonly artifacts = inject(ArtifactService);
  private readonly registry = inject(ARTIFACT_RENDERERS);

  /** Resolve the renderer component for an artifact type; markdown is the default. */
  rendererFor(type: string): Type<unknown> {
    return this.registry[type] ?? MarkdownArtifactComponent;
  }

  onClose(): void {
    this.artifacts.close();
  }

  onOpenNewTab(): void {
    this.artifacts.openInNewTab(this.artifacts.activeArtifact());
  }

  onDownload(): void {
    void this.artifacts.download(this.artifacts.activeArtifact());
  }
}
